function e(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
export {
  e as default
};
